module.exports = __webpack_public_path__ + "img/moneybag.5fafec10.png";